export default {"src":"/_next/static/image/public/images/ic_trash_white.e413d7b97f91a2b78cd2b0ef17198b6b.svg","height":20,"width":18};